import React from "react";
import { Modal } from "../../components/ui";
import SendPaymentLinkModal from "../../order/components/ItemProduct/SendPaymentLinkModal";
import CollectionForm from "../../requests/v2/CollectionForm";

/** The two dialogs an action button can open (see useDashboardCta). */
export default function CtaModals({ cta }) {
  const pl = cta.paymentLink;
  const col = cta.collectionFor;
  return (
    <>
      {pl ? (
        <SendPaymentLinkModal open onClose={cta.closePaymentLink} order={pl.order} presetAmountPence={pl.presetAmountPence} />
      ) : null}
      {col ? (
        <Modal open onClose={() => cta.closeCollection(false)} size="sm" title="Book collection" description={col.title}>
          <CollectionForm
            requestId={col.entity.request_id}
            initialAt={col.entity.collection_at || null}
            initialNote={col.entity.collection_note || null}
            onCancel={() => cta.closeCollection(false)}
            onSaved={(saved) => cta.closeCollection(saved)}
          />
        </Modal>
      ) : null}
    </>
  );
}
